import React, { ReactNode } from "react";
import { Routes, Route, Outlet } from "react-router-dom";

// Campaign Pages
import Campaigns from "pages/campaigns/Campaigns";

// Layout
import Navbar_Internal from "components/PageLayouts/PageFrames/navbar_internal";
import Footer_Internal from "components/PageLayouts/PageFrames/footer_internal";
import { Box } from "@mui/material";
import Sidebar_Campaigns from "components/PageLayouts/PageFrames/sidebar_campaigns";


interface InternalLayoutProps {
  children: ReactNode;
}

const InternalLayout = ({ children }: InternalLayoutProps) => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar_Internal />
    <Box sx={{ flex: 1 }}>{children}</Box>
    <Footer_Internal />
  </Box>
);

const CampaignsLayout = () => (
  <Box sx={{ display: "flex", flex: 1 }}>
    <Sidebar_Campaigns />
    <Outlet />
  </Box>
);


export default function CampaignsModule() {
  return (
    <Routes>
        <Route element={<InternalLayout><Outlet /></InternalLayout>}>
            <Route element={<CampaignsLayout />}>
                <Route path="/" element={<Campaigns />} />
                <Route path="/:id/" element={<Campaigns />} />
            </Route>
        </Route>
    </Routes>
  );
}
